import { FINANCE } from 'consts';

export const STATUS_NEW = 0;
export const STATUS_DELETED = 1;
export const STATUS_REJECTED = 2;
export const STATUS_TERMINATED = 3;
export const STATUS_EXPIRED = 4;
export const STATUS_DRAFT = 5;
export const STATUS_MORE_INFO = 6;
export const STATUS_PENDING_LEGAL = 7;
export const STATUS_PENDING = 8;
export const STATUS_PENDING_TL = 9;
export const STATUS_PENDING_DR = 10;
export const STATUS_PENDING_VP = 11;
export const STATUS_PENDING_BC = 12;
export const STATUS_PENDING_FM = 13;
export const STATUS_PENDING_CFO = 14;
export const STATUS_PENDING_PARTNER = 15;
export const STATUS_SIGNED = 16;
export const STATUS_PENDING_CMO = 17;

export const STATUS_COLOR_MAP = new Map([
  [STATUS_NEW, 'inactive'],
  [STATUS_DELETED, 'inactive'],
  [STATUS_REJECTED, 'danger'],
  [STATUS_TERMINATED, 'danger'],
  [STATUS_EXPIRED, 'danger'],
  [STATUS_DRAFT, 'draft'],
  [STATUS_MORE_INFO, 'info'],
  [STATUS_PENDING_LEGAL, 'processing'],
  [STATUS_PENDING, 'processing'],
  [STATUS_PENDING_TL, 'processing'],
  [STATUS_PENDING_DR, 'processing'],
  [STATUS_PENDING_VP, 'processing'],
  [STATUS_PENDING_BC, 'processing'],
  [STATUS_PENDING_FM, 'processing'],
  [STATUS_PENDING_CFO, 'processing'],
  [STATUS_PENDING_PARTNER, 'processing'],
  [STATUS_SIGNED, 'success'],
  [STATUS_PENDING_CMO, 'processing'],
]);

export const TAB_DETAILS = 'details';
export const TAB_ATTACHMENTS = 'attachments';
export const TAB_ACTIONS_LOG = 'actions-logs';

export const getRoute = (id: number) => {
  return `/${FINANCE}/io/${id}/${TAB_DETAILS}`;
};

export const ACTION_APPROVE = 'Approve';
export const ACTION_REJECT = 'Reject';
export const ACTION_MORE_INFO = 'RequestMoreInfo';
export const ACTION_UNDO = 'Undo';

export const SIGN_STATUS_PENDING = 0;
export const SIGN_STATUS_APPROVED = 1;
export const SIGN_STATUS_REJECTED = 2;

export const NETWORK_WEB = 0;
export const NETWORK_MOBILE = 1;

export const AGREEMENT_TYPE_INTERNAL = 0;
